module.exports = __webpack_public_path__ + "static/media/IMG_1332.60225c15.jpg";